import { createClsNameMap } from '@utils';

export const clsNameMap = createClsNameMap({})('placeholder');

export type PlaceholderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
> & {
  width?: number | string;
  height?: number | string;
  style?: React.StyleHTMLAttributes<HTMLSpanElement>;
};

const Placeholder = ({ width, height, style, ...attrs }: PlaceholderProps) => {
  return (
    <span
      className={clsNameMap.root()}
      {...attrs}
      style={{
        ...style,
        width,
        height,
      }}
    ></span>
  );
};

export default Placeholder;
